export default __webpack_public_path__ + "static/media/Update-Adress.9c7c397a.jpg";